import React from 'react';
import { Paper, Button } from '@material-ui/core';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { MainRoute } from '../../library/Routes';

export interface IError404 extends RouteComponentProps<any> {

}

class Error404 extends React.Component<IError404> {
  render() {
    return (
      <Paper>
        Página não encontrada!<br />
        <br />
        <Button
          onClick={() => {
            const mainPath: string | undefined = MainRoute.path;
            if (typeof mainPath === 'string') {
              this.props.history.push(mainPath);
            }
          }}>
            Voltar para a Home
        </Button>
      </Paper>
    );
  }
}

export default withRouter(Error404);